import { render, staticRenderFns } from "./PosVersionsTable.vue?vue&type=template&id=07098a9d&"
import script from "./PosVersionsTable.vue?vue&type=script&lang=js&"
export * from "./PosVersionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports